<template>
  <div class="mb-3">
    <v-card
      v-if="logoUrl || uploading"
      class="mb-3 d-flex"
      height="120"
    >
    <v-progress-circular
    v-if="uploading"
    indeterminate
    size="40"
  />
      <v-img
      v-else
        :src="previewUrl || logoUrl"
        max-height="100"
        contain
        alt="company logo preview"
      />
    </v-card>
    <v-btn
      type="button"
      variant="text"
      prepend-icon="mdi-file-image"
      @click="triggerFileSelect"
    >
  {{ fileName || 'Upload Company Logo' }}
</v-btn>

    <input
      ref="fileInput"
      type="file"
      accept="image/*"
      hidden
      @change="onFileSelected"
      aria-label="Company Logo filename input"
    />
  </div>
</template>

<script setup>
import { ref, computed, inject, onMounted} from "vue"
import { useS3Upload } from "@/composables/file"
import { checkCompanySSOEnabled } from '@/services/entityService'
const uploading = ref(false)
const {path} = inject("entityState")
const updateEntity = inject("updateEntity")
defineOptions({
  inheritAttrs: false
})
const props = defineProps({
  label: String,
  modelValue: String
})
const logoUrl = ref(null)
const fileInput = ref(null)
const previewUrl = ref(null)
const selectedFile = ref(null)

onMounted(async () => {
  if( props.modelValue === null) return 
  if(!path) return 
  const { logoUrl: url } = await checkCompanySSOEnabled(path) 
  if (url && !url.startsWith("http")) {
    logoUrl.value = `https://${url}`
  } else {
    logoUrl.value = url
  }
})

const {getPresignedS3Url, uploadToS3, hasNewFile} = useS3Upload()

const fileName = computed(() => {
  return selectedFile.value?.name || ""
})

const triggerFileSelect = () => {
  fileInput.value?.click()
}
const onFileSelected = async (event) => {
  uploading.value = true
  try{
    const file = event.target.files?.[0]
    if (!file) {
      selectedFile.value = null
      previewUrl.value = null
      return
    }
    
    selectedFile.value = file
    previewUrl.value = URL.createObjectURL(file)
  
    await getPresignedS3Url(path, file)
  
    await uploadToS3()
    updateEntity("logo", file?.name)
  }finally{
    uploading.value = false
  }

  
}

</script>